import styled from 'styled-components'

export const Modal = styled.div`
  top: 0;
  z-index: 99999;

  & div[class^='Contentstyled__Content'] {
    padding: 3rem 4rem 4rem;
  }

  @media (max-width: 767px) {
    & div[class^='Contentstyled__Content'] {
      padding: 2rem;
    }

    & div[class^='Headerstyled__Header'] {
      padding: 2rem;
    }

    & div[class^='Modalstyled__Modal'] {
      width: auto;
      max-width: 400px;
    }
  }
`

export const ModalTitle = styled.h4`
  margin: 0;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 26px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  @media (max-width: 767px) {
    row-gap: 20px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;

  @media (max-width: 767px) {
    row-gap: 20px;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  @media (max-width: 767px) {
    row-gap: 10px;
  }
`

export const Title = styled.h6<{ isShort: boolean }>`
  margin: 0;
  display: flex;
  column-gap: 10px;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  flex: ${({ isShort }) => (isShort ? '0 0 100px' : '0 0 18px')};

  color: ${({ theme }) => theme.palette.black[20]};

  @media (max-width: 767px) {
    flex-basis: unset;
  }
`

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  color: ${({ theme }) => theme.palette.black[20]};
`
